<template>
    <p 
      class="close-button" 
      @click.prevent="$emit('click')"
    >
        ✕
    </p>
  </template>
  
  <script>
  export default {
    name: 'CancelModal',
  }
  </script>

  <style>
    .close-button {
        font-size: 16px;
        cursor: pointer;
        margin: 0px;
    }
  </style>